// reducers/listReducer.js
import { FETCH_SYNTHESE_ANNEE_SUCCESS, FETCH_SYNTHESE_ANNEE_FAILURE,REDIRECT_TO_LOGIN } from './actionsTypes';

const initialState = {
  syntheseAnneeData: [],
  error: null,
  redirectToLoginPage: false,
};

const syntheseAnneeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SYNTHESE_ANNEE_SUCCESS:
      return {
        ...state,
        syntheseAnneeData: action.payload.syntheseAnneeData,
        error: null,
      };
    case FETCH_SYNTHESE_ANNEE_FAILURE:
      return {
        ...state,
        syntheseAnneeData: [],
        error: action.payload.error,
      };
    case REDIRECT_TO_LOGIN:
        return {
            ...state,
            redirectToLoginPage: true,
        };
    default:
      return state;
  }
};

export default syntheseAnneeReducer;
